import React from 'react';

import { Box } from '@mui/material';

import OrderBrandWarningMessage from '~/components/Purchases/OrderDetail/OrderBrandWarningMessage';
import TenancyWarningMessage from '~/components/Users/UserDetails/TenancyWarningMessage';
import { validUserTenantForSiteTenant } from '~/components/Users/UserDetails/utils';

import useCurrentTenant from '~/hooks/useCurrentTenant';

type Props = {
  orderBrand?: string;
  userTenant?: string;
};

export default function TenantMismatchAlerts({ orderBrand, userTenant }: Props) {
  const { tenant } = useCurrentTenant();
  const showOrderBrandWarning = Boolean(orderBrand) && tenant.brand !== orderBrand;
  const showUserTenancyWarning =
    !showOrderBrandWarning && Boolean(userTenant) && !validUserTenantForSiteTenant(tenant.value, userTenant ?? '');

  if (!showOrderBrandWarning && !showUserTenancyWarning) {
    return null;
  }

  return (
    <Box sx={{ mb: 2 }}>
      {showOrderBrandWarning && orderBrand && <OrderBrandWarningMessage brand={orderBrand} />}
      {showUserTenancyWarning && userTenant && <TenancyWarningMessage userTenant={userTenant} />}
    </Box>
  );
}
